
export type GetUserProfile200SocialLinks = {
  github?: string;
  linkedin?: string;
  twitter?: string;
};
